import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface Props {
  /** Size of the spinner in pixels */
  size?: number
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'LoadingSpinner'
},
  __name: 'LoadingSpinner',
  props: {
    size: { default: 30 }
  },
  setup(__props: any) {





const style = computed(() => {
  return `
    border: ${__props.size * 0.15}px solid rgba(0, 0, 0, 0.1);
    height: ${__props.size}px; width: ${__props.size}px;
    border-radius: 50%;`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "alert",
    "aria-busy": "true",
    class: "donut-spinner text-primary",
    style: _normalizeStyle(style.value)
  }, null, 4))
}
}

})